import { ActionMenu } from '../../Components/ActionMenu/ActionMenu';
import { Column, LeaderboardTab, LeaderboardRow } from './types';
import React from 'react';
import { Icons } from '../../Components/Icons/Icons';

export const LEADERBOARD_TABS = [
  { id: 'participants' as LeaderboardTab, label: 'Participants' },
  { id: 'areas' as LeaderboardTab, label: 'Areas' },
  { id: 'offices' as LeaderboardTab, label: 'Offices' },
];

const renderRating: (row: LeaderboardRow) => React.ReactNode = (row) => {
  return <div className={`rating-badge rating-${row.rating}`}> {row.rating} </div>;
};

const renderName: (row: LeaderboardRow) => React.ReactNode = (row) => {
  return (
    <div className="name-cell">
      <div className="avatar">
        {row.name
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase())
          .join('')}
      </div>
      <span className="name"> {row.name} </span>
    </div>
  );
};

const renderScore: (row: LeaderboardRow) => React.ReactNode = (row) => {
  return <span className="score-value">{row.score}</span>;
};

const ActionCell: React.FC<{
  onAddReviewClick: (id: string) => void;
  onAddCaseClick: (id: string, agency?: string, name?: string) => void;
  onDeleteReviewClick: (id: string) => void;
  onViewCasesClick: (id: string) => void;
  row: LeaderboardRow;
}> = ({ onAddReviewClick, onAddCaseClick, onDeleteReviewClick, onViewCasesClick, row }) => {
  const actions = [
    {
      label: 'View Cases',
      icon: Icons.View,
      onClick: () => onViewCasesClick(String(row.id)),
    },
    {
      label: 'Add Hours',
      icon: Icons.AddHours,
      onClick: () => onAddCaseClick(String(row.id), row.agency, row.name),
    },
    {
      label: 'Add Review',
      icon: Icons.AddReview,
      onClick: () => onAddReviewClick(String(row.id)),
    },
    {
      label: 'View Reviews',
      icon: Icons.View,
      onClick: () => onDeleteReviewClick(String(row.id)),
    },
  ];

  return <ActionMenu actions={actions} />;
};

const renderAction =
  (
    onAddReviewClick: (id: string) => void,
    onAddCaseClick: (id: string, agency?: string, name?: string) => void,
    onDeleteReviewClick: (id: string) => void,
    onViewCasesClick: (id: string) => void
  ) =>
  (row: LeaderboardRow) => {
    return (
      <ActionCell
        onAddReviewClick={onAddReviewClick}
        onAddCaseClick={onAddCaseClick}
        onDeleteReviewClick={onDeleteReviewClick}
        onViewCasesClick={onViewCasesClick}
        row={row}
      />
    );
  };

export const getColumns = (
  activeTab: LeaderboardTab,
  onAddReviewClick: (id: string) => void,
  onAddCaseClick: (id: string, agency?: string, name?: string) => void,
  onDeleteReviewClick: (id: string) => void,
  onViewCasesClick: (id: string) => void
): Column[] => {
  switch (activeTab) {
    case 'participants':
      return [
        { id: 'rating', label: 'Rating', render: renderRating, width: '5%' },
        { id: 'name', label: 'Name', render: renderName, width: '20%' },
        { id: 'hours', label: 'Hours', width: '8%' },
        { id: 'clients', label: 'Clients', width: '8%' },
        { id: 'totalReviews', label: 'Total Reviews', width: '10%' },
        { id: 'score', label: 'Score', width: '10%', render: renderScore },
        { id: 'area', label: 'Area', width: '10%' },
        { id: 'office', label: 'Office', width: '10%' },
        { id: 'agency', label: 'Agency', width: '10%' },
        { id: 'lastUpdate', label: 'Last update', width: '14%' },
        {
          id: 'action',
          label: 'Action',
          render: renderAction(
            onAddReviewClick,
            onAddCaseClick,
            onDeleteReviewClick,
            onViewCasesClick
          ),
          width: '5%',
        },
      ];
    case 'areas':
      return [
        { id: 'rating', label: 'Rating', width: '5%' },
        { id: 'area', label: 'Area', width: '20%' },
        { id: 'hours', label: 'Hours', width: '8%' },
        { id: 'clients', label: 'Clients', width: '8%' },
        { id: 'totalReviews', label: 'Total Reviews', width: '10%' },
        { id: 'score', label: 'Score', width: '10%', render: renderScore },
        { id: 'lastUpdate', label: 'Last update', width: '14%' },
      ];
    case 'offices':
      return [
        { id: 'rating', label: 'Rating', width: '5%' },
        { id: 'office', label: 'Office', width: '20%' },
        { id: 'hours', label: 'Hours', width: '8%' },
        { id: 'clients', label: 'Clients', width: '8%' },
        { id: 'totalReviews', label: 'Total Reviews', width: '10%' },
        { id: 'score', label: 'Score', width: '10%', render: renderScore },
        { id: 'area', label: 'Area', width: '10%' },
        { id: 'agency', label: 'Agency', width: '10%' },
        { id: 'lastUpdate', label: 'Last update', width: '14%' },
      ];
    default:
      return [];
  }
};
